( function( $ ) {
    $( function() {
        var openMenu = $( '.sl__header__hamburguer' );
        var menu = $( '.sl__header__nav' );
        var header = $( '.sl__header' );
        var headerTop = header.outerHeight();
        var jsScroll = $( '.js-scroll' );
		var tabsLi = $( '.sl__fenologia__tab__header li' );
		var tabContent = $( '.sl__fenologia__tab__content' );
		var search = $( '#search' );

		//var cardName = $( '.sl__card__grid .card-product .info .name' );
		//var maxHeight = -1;

		search.keyup( function( event ) {
			if ( event.which === 13 ) {
				location.href = ProductData.permalink + '?search=' + $( this ).val();
			}
		});

        openMenu.click( function( e ) {
			e.preventDefault();
			$( this ).toggleClass( 'active' );
            menu.toggleClass( 'active' );
            header.toggleClass( 'active' );
        });
        function FixHeader() {
			if ( document.documentElement.scrollTop || document.body.scrollTop > headerTop ) {
				header.addClass( 'fixed' );
			} else {
				header.removeClass( 'fixed' );
			}
			setTimeout( FixHeader, 1 );
		}
		FixHeader();
        jsScroll.click( function( e ) {
			var $this = $( this );
			var linkHref = $this.attr( 'href' );
			$( 'html, body' ).animate({
                scrollTop: $( linkHref ).offset().top - headerTop
            }, 1000 );
			e.preventDefault();
			return false;
		});
		tabsLi.click( function() {
			var tabId = $( this ).attr( 'data-tab' );

			tabsLi.removeClass( 'current' );
			tabContent.removeClass( 'current' );

			$( this ).addClass( 'current' );
			$( '#' + tabId ).addClass( 'current' );
		});

		//cardName.each( function() {
			//if ( $( this ).height() > maxHeight ) {
				//maxHeight = $( this ).height();
			//}
		//});
		//cardName.height( maxHeight );
    });
}( jQuery ) );
